/*
 * JavaScript Load Image Fetch
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2017, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, fetch, Request */

;(function (factory) {
  'use strict'
  if (typeof define === 'function' && define.amd) {
    // Register as an anonymous AMD module:
    define(['./load-image', './load-image-meta'], factory)
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
}(function (loadImage) {
  'use strict'

  if ('fetch' in window && 'Request' in window) {
    loadImage.fetchBlob = function (url, callback, options) {
      if (loadImage.hasMetaOption(options)) {
        return fetch(new Request(url, options)).then(function (response) {
          return response.blob()
        }).then(callback).catch(function (err) {
          console.log(err)
          callback()
        })
      } else {
        callback()
      }
    }
  }
}))



//////////////////
// WEBPACK FOOTER
// ./~/blueimp-load-image/js/load-image-fetch.js
// module id = 249
// module chunks = 0 1 10 11 21